import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

tippy.setDefaultProps({
    arrow: true,
    trigger: 'mouseenter',
    appendTo: 'parent',
    allowHTML: true,
    // theme: 'light',
});

window.tippy = tippy;
